module.exports = __webpack_public_path__ + "1-22.png?fd7370224892ce83ba98043d47130a8f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-22.png
// module id = 99
// module chunks = 0